import React from 'react';

// @material-ui/core
import { Hidden, makeStyles, } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
// core
import CustomizedAccordions from './CustomizedAccordion/CustomizedAccordion';
import CustomizedLessons from './CustomizedAccordion/CustomizedLessonBlock';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: '16px',
        marginBottom: '32px',
    },
    expandLink: {
        cursor: 'pointer',
        color: theme.palette.colors.orange[300],
        fontWeight: 500,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'none',
        }
    },
    gridTitle:{
        marginBottom: 24,
        [theme.breakpoints.down('xs')]:{
            marginBottom: 4,
            '& .title':{
                marginBottom: 4
            }
        }
    }
}));

function counterLessons(datos) {
    let cantidadTotal = 0;
  
    // Recorrer cada nodo en el array de datos
    datos.forEach((nodo) => {
      // Verificar si el nodo tiene la propiedad "topics" y es un array
      if (nodo.topics && Array.isArray(nodo.topics)) {
        // Contar solo los topics que tienen name
        const topicsWithName = nodo.topics.filter(t => t?.name && t?.name.trim() !== '');
        cantidadTotal += topicsWithName.length;
      }
    });
  
    return cantidadTotal;
}


const Topics = ({ data }) => {
    const classes = useStyles();
    const [expandAll,setExpandAll]=React.useState(false);

    const toggleExpandAll=({event})=>{
        setExpandAll(!expandAll);
    };

    if (!(data && data.length > 0)) {
        return null;
    }

    // Filtrar módulos que tienen name
    const modulesWithName = data.filter(el => el?.name && el?.name.trim() !== '');
    
    if (modulesWithName.length === 0) {
        return null;
    }

    const totalModules = modulesWithName.length;
    const totalLessons = counterLessons(modulesWithName);
    const isModulesStructure = modulesWithName[0]?.section_type_id == 1;

    return (
        <div className="pb-2" id="topics-root">
            <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} sm={6} className={classes.gridTitle}>
                    <Typography variant="h3" className='title'>Contenido del curso</Typography>
                    <Hidden smUp>
                        <Typography variant="caption" className='text-gray-400'>{`${totalModules} temas, ${totalLessons} lecciones`}</Typography>
                    </Hidden>
                    <Hidden xsDown>
                        <Typography variant="body2" style={{ marginTop: '8px', color: '#FFFFFF' }}>
                            {`${totalModules} Módulos, ${totalLessons} Lecciones`}
                        </Typography>
                    </Hidden>
                </Grid>
                <Grid item xs={12} sm={6} style={{ textAlign: 'right' }}>
                    {isModulesStructure && (
                        <Typography 
                            onClick={toggleExpandAll} 
                            className={classes.expandLink}
                            variant="body2"
                        >
                            {expandAll ? "Ocultar todo" : "Expandir todo"}
                        </Typography>
                    )}
                </Grid>
            </Grid>
            { isModulesStructure ? 
                modulesWithName.map((el) => {
                    if (!el || !el.id) return null;
                    const allTopics = Array.isArray(el?.topics) ? el.topics : [];
                    // Filtrar topics que tienen name
                    const moduleTopics = allTopics.filter(t => t?.name && t?.name.trim() !== '');
                    return (
                        <CustomizedAccordions
                            key={`topic-${el.id}`}
                            id={`topic-${el.id}`}
                            title={el.name}
                            topics={moduleTopics}
                            allExpanded={expandAll}
                        >
                            {
                                moduleTopics.length > 0 ? (
                                    <List dense>
                                        {
                                            moduleTopics.map(t => (
                                                <ListItem key={t?.id} alignItems="flex-start">
                                                    <ListItemText primary={
                                                        <Typography variant="h6">{t.name}</Typography>
                                                    }></ListItemText>
                                                </ListItem>
                                            ))
                                        }
                                    </List>
                                ) : null
                            }
                        </CustomizedAccordions>
                    );
                })
            :
                modulesWithName.map((el) => (
                    <CustomizedLessons 
                        key={`lesson-${el.id}`}
                        id={`topic-${el.id}`}
                        title={el.name}>

                    </CustomizedLessons>
                ))
            }
        </div>
    );
};

export default Topics;